import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { trackListingJKClick } from './tracking';
import { closePromoDetails } from '../../actions/promoDetails';
import { PromoDetailsModal } from '../../components/PromoDetailsModal';
import { selectIsPromoDetailsOpen, selectPromoDetails, selectPromoProduct } from '../../selectors/promoDetails';
import { IPromoProduct } from '../../types/product';
import { NewbuildingLinkContainer } from '../NewbuildingsLinkContainer/NewbuildingLinkContainer';

export const PromoDetailsModalContainer = () => {
  const isOpen = useSelector(selectIsPromoDetailsOpen);
  const promoDetails = useSelector(selectPromoDetails);
  const promoProduct = useSelector(selectPromoProduct);
  const dispatch = useDispatch();

  const closePromoDetailsModal = React.useCallback(() => {
    dispatch(closePromoDetails());
  }, [dispatch]);

  const handleLinkClick = React.useCallback(() => {
    trackListingJKClick({ product: promoProduct as IPromoProduct });
  }, [promoProduct]);

  if (!isOpen || !promoDetails) {
    return null;
  }

  return (
    <PromoDetailsModal
      onClose={closePromoDetailsModal}
      banks={promoDetails.banks}
      builders={promoDetails.builders}
      name={promoDetails.promoName}
      logo={promoDetails.providerLogo}
      description={promoDetails.promoDescription}
      features={promoDetails.promoProps}
      newbuildingButton={
        <NewbuildingLinkContainer
          desktopUrl={promoDetails.newbuildingListingUrlDesktop}
          mobileUrl={promoDetails.newbuildingListingUrlMobile}
          onClick={handleLinkClick}
        />
      }
    />
  );
};
